import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable()
export class HomeService {
  token: string;
  api_url: string = environment.apiEndPoint;

  constructor(private http: HttpClient) {}

  getToken() {
    if (!this.token)
      this.token = localStorage.getItem(environment.TOKEN_SECRET);
    return this.token;
  }

  geAllHomes() {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(this.api_url + "home");
  }
  saveHomes(obj) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    if (obj._id) {
      return this.http.put<any>(this.api_url + "home/" + obj._id, obj, configs);
    }
    return this.http.post<any>(this.api_url + "home", obj, configs);
  }
  deleteHome(obj) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
      body: obj,
    };
    return this.http.delete<any>(this.api_url + "home/" + obj._id, configs);
  }
//   getHome(job_id) {
//     return this.http.get<any>(this.api_url + "home/" + _id);
//   }
}



// WEBPACK FOOTER //
// ./src/app/home/home.service.ts